export default [
  {
    path: '/compactor/:id/path',
    name: 'compactor.path',
    component: () => import('@/views/maps/CompactorPath.vue'),
    meta: {
      layout: 'full',
    },
  },
]
